// A task tracked again from a saved copy (a resume) carries the others' tracking status from when it was saved.
// My own tracked user stays as it is here, its time ticks locally; the others take the status the API answered.
export function withOthersTrackingStatus(ttbus, apiTtbus, myUserId) {
  const online = new Map(apiTtbus.map(ttbu => [ttbu.id, ttbu.trackingOnline]));
  return (ttbus || []).map(ttbu => (ttbu.userId !== myUserId && online.has(ttbu.id)
    ? { ...ttbu, trackingOnline: online.get(ttbu.id) }
    : ttbu));
}
